import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ReactModal from 'react-modal';
import AppRouter from './app/router';

import store from './app/store';

import '../sass/app.sass';

function normalizeLegacyHashRoutes() {
    const h = window.location.hash;
    if (!h || h === '#') return;
    if (!h.startsWith('#/')) return;

    const raw = h.slice(1);
    const [path, hashQuery] = raw.split('?');
    const search = hashQuery ? `?${hashQuery}` : window.location.search;

    window.history.replaceState(null, '', `${path}${search}`);
}

normalizeLegacyHashRoutes();

ReactModal.setAppElement('#main-content');

createRoot(document.getElementById('main-content')).render(
    <Provider store={store}>
        <AppRouter />
    </Provider>
);
